import { CodeResult } from '../types';
import { CallFunctionParams } from './types';

export const callFunction = async <
  Resp,
  Req extends Record<string, any> = { [c: string]: any }
>(
  params: CallFunctionParams<Req>
) => {
  const { provider, accountId, method, args = {} } = params;

  const response = await provider.query<CodeResult>({
    request_type: 'call_function',
    account_id: accountId,
    method_name: method,
    args_base64: Buffer.from(JSON.stringify(args)).toString('base64'),
    finality: 'optimistic',
  });

  const parsedResponse = JSON.parse(
    Buffer.from(response.result).toString()
  ) as Resp;

  return parsedResponse;
};
